import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';

export function Layout(props: { children?: React.ReactNode; isAuthenticated?: any; }) {
  let displayName = Layout.name;

  return (
    <div>
      <NavMenu isAuthenticated={props.isAuthenticated} />
      {props.children}
    </div>
  );
}
